export default __webpack_public_path__ + "static/media/nursery-benefit-disabled.fdfd5120.png";